import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "relative h-11 w-full flex items-center justify-between bg-main-100 shrink-0 select-none text-xs"
};
const _hoisted_2 = {
  class: "h-full flex items-center gap-4 overflow-hidden px-3"
};
const _hoisted_3 = {
  key: 0,
  class: "w-fit hidden md:block text-white truncate overflow-hidden"
};
const _hoisted_4 = {
  class: "font-bold"
};
const _hoisted_5 = {
  class: "h-full flex items-center gap-4"
};
const _hoisted_6 = {
  key: 0,
  class: "max-md:hidden text-white font-medium"
};
const _hoisted_7 = {
  key: 1,
  class: "fixed top-0 right-0 h-11 w-[160px] flex shrink-0 text-white ml-auto drag-none",
  style: {
    "z-index": "1000"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HamburgerButton = _resolveComponent("HamburgerButton");
  return _openBlock(), _createElementBlock(_Fragment, null, [_cache[11] || (_cache[11] = _createElementVNode("div", {
    class: "fixed top-0 left-0 h-11 w-full drag"
  }, null, -1)), !this.hidden ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_HamburgerButton, {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$state.navigationMenuOpen = !_ctx.$state.navigationMenuOpen),
    open: _ctx.$state.navigationMenuOpen,
    onFocus: _cache[1] || (_cache[1] = $event => this.$handleFocusGroup(() => _ctx.$state.navigationMenuOpen = false)),
    "focus-group": "navigation-menu-controller"
  }, null, 8, ["open"]), _ctx.$state.currentUser?.userData ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.$st('app.hello')) + " ", 1), _createElementVNode("span", _hoisted_4, _toDisplayString(' ' + _ctx.$state.currentUser?.userData.name), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [this.userSubscription.active && !this.userSubscription.trialing ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(this.$appConfig.company_name) + " Plan " + _toDisplayString(this.userSubscription.name), 1)) : _createCommentVNode("", true), this.userSubscription.balance !== undefined ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "h-7 flex items-center gap-2 bg-pro_dark text-white px-3 rounded-2xl shadow-weak_material cursor-pointer",
    onClick: _cache[2] || (_cache[2] = $event => this.$router.push({
      name: 'Payments'
    }))
  }, [_cache[6] || (_cache[6] = _createElementVNode("i", {
    class: "icon-diamond text-base"
  }, null, -1)), _createTextVNode(" " + _toDisplayString(this.$st('payments.current-slans', {
    value: this.userSubscription.balance
  })), 1)])) : _createCommentVNode("", true)]), _cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "h-full w-[160px]"
  }, null, -1))])) : _createCommentVNode("", true), _ctx.$state.embedded ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", {
    class: "h-full w-full flex items-center justify-center outline-none border-none cursor-default hover:bg-window-button",
    onClick: _cache[3] || (_cache[3] = $event => this.MinimizeWindow())
  }, _cache[8] || (_cache[8] = [_createElementVNode("i", {
    class: "icon-window-min text-2xs"
  }, null, -1)])), _createElementVNode("div", {
    class: "h-full w-full flex items-center justify-center outline-none border-none cursor-default hover:bg-window-button",
    onClick: _cache[4] || (_cache[4] = $event => this.MaximizeWindow())
  }, _cache[9] || (_cache[9] = [_createElementVNode("i", {
    class: "icon-window-max text-2xs"
  }, null, -1)])), _createElementVNode("div", {
    class: "h-full w-full flex items-center justify-center outline-none border-none cursor-default hover:bg-window-quit",
    onClick: _cache[5] || (_cache[5] = $event => this.CloseWindow())
  }, _cache[10] || (_cache[10] = [_createElementVNode("i", {
    class: "icon-window-quit text-2xs"
  }, null, -1)]))])) : _createCommentVNode("", true)], 64);
}